import React from 'react';
import { useAdmin } from '../context/AdminContext';
import AuthForm from './AuthForm';
import PendingApproval from './PendingApproval';
import AdminDashboard from './AdminDashboard';

const AdminPanel = () => {
  const {
    currentUser,
    isAdmin,
    loading: authLoading
  } = useAdmin();

  // Show loading while checking auth state
  if (authLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Not logged in
  if (!currentUser) {
    return <AuthForm />;
  }

  // Not admin - Pending approval or regular user
  if (!isAdmin) {
    return <PendingApproval currentUser={currentUser} />;
  }

  // Admin dashboard
  return <AdminDashboard currentUser={currentUser} />;
};

export default AdminPanel;